<mat-icon
  class="filter"
  [ngClass]="form.value.clear != 0 ? 'dataFil' : ''"
  mat-button
  [matMenuTriggerFor]="animals"
  >tune</mat-icon
>
<mat-menu #animals="matMenu">
  <p class="tilte">Filtrar {{ title }}</p>
  <div class="paddingDiv" (click)="$event.stopPropagation()">
    <!-- <button (click)="date = !date" (click)="filter()" mat-menu-item>
      Fecha <span></span>
    </button> -->
    <form [formGroup]="form">
      <div>
        <!-- <mat-checkbox
          formControlName="date"
          (change)="filter()"
          class="check custom-checkbox"
          >Fecha
          <mat-icon *ngIf="form.date">keyboard_arrow_up</mat-icon></mat-checkbox
        > -->
        <button
          (click)="filter()"
          (click)="form.value.date = !form.value.date"
          class="paddingLeft"
          matTooltip="Ordenar por timepo"
          mat-menu-item
        >
          <mat-icon class="icons">calendar_today</mat-icon> Fecha
          <mat-icon *ngIf="form.value.clear == 1">{{
            form.value.date ? "keyboard_arrow_up" : "keyboard_arrow_down"
          }}</mat-icon>
        </button>
      </div>
      <div>
        <mat-icon class="icons">person_outline</mat-icon>
        <mat-form-field class="matform" appearance="standard">
          <mat-label>Asignado</mat-label>
          <mat-select formControlName="analist" (selectionChange)="filter()">
            <mat-option *ngFor="let user of users" [value]="user._id">{{
              user.fullname
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div>
        <mat-icon class="icons">short_text</mat-icon>
        <mat-form-field class="matform" appearance="standard">
          <mat-label>Tipo de caso</mat-label>
          <mat-select formControlName="caseType" (selectionChange)="filter()">
            <mat-option
              *ngFor="let caseType of caseTypes"
              [value]="caseType._id"
              >{{ caseType.name }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
    </form>
    <div>
      <button
        (click)="clear()"
        class="center"
        matTooltip="Limpiar filtros"
        mat-menu-item
      >
        Limpiar
      </button>
    </div>
  </div>
  <!-- <button mat-menu-item [matMenuTriggerFor]="vertebrates">Vertebrates</button> -->
</mat-menu>

<!-- <mat-menu #vertebrates="matMenu">
  <button mat-menu-item [matMenuTriggerFor]="fish">Fishes</button>
  <button mat-menu-item [matMenuTriggerFor]="amphibians">Amphibians</button>
  <button mat-menu-item [matMenuTriggerFor]="reptiles">Reptiles</button>
  <button mat-menu-item>Birds</button>
  <button mat-menu-item>Mammals</button>
</mat-menu>

 <mat-menu #invertebrates="matMenu">
  <button mat-menu-item>Insects</button>
  <button mat-menu-item>Molluscs</button>
  <button mat-menu-item>Crustaceans</button>
  <button mat-menu-item>Corals</button>
  <button mat-menu-item>Arachnids</button>
  <button mat-menu-item>Velvet worms</button>
  <button mat-menu-item>Horseshoe crabs</button>
</mat-menu> 

<mat-menu #fish="matMenu">
  <button mat-menu-item>Baikal oilfish</button>
  <button mat-menu-item>Bala shark</button>
  <button mat-menu-item>Ballan wrasse</button>
  <button mat-menu-item>Bamboo shark</button>
  <button mat-menu-item>Banded killifish</button>
</mat-menu>

<mat-menu #amphibians="matMenu">
  <button mat-menu-item>Sonoran desert toad</button>
  <button mat-menu-item>Western toad</button>
  <button mat-menu-item>Arroyo toad</button>
  <button mat-menu-item>Yosemite toad</button>
</mat-menu>

<mat-menu #reptiles="matMenu">
  <button mat-menu-item>Banded Day Gecko</button>
  <button mat-menu-item>Banded Gila Monster</button>
  <button mat-menu-item>Black Tree Monitor</button>
  <button mat-menu-item>Blue Spiny Lizard</button>
  <button mat-menu-item disabled>Velociraptor</button>
</mat-menu>
-->
